var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layerpopup-cont type-2",staticStyle:{"border":"none","width":"800px","max-height":"450px"}},[_c('modal-iframe',{attrs:{"src":_vm.remoteSrc,"spinner-id":"otp-setting-loading","custom-style":{'height': '420px'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }